import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner, Alert, } from 'reactstrap';
import UploadEvidenceForm from '../../Forms/Evidence/UploadEvidenceForm';

const UploadEvidenceModal = ({ data, isOpen, handleToggleModal, showDetails}) => {
	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handleToggleModal()}
				size='lg'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader toggle={handleToggleModal}>Cargar Evidencia</ModalHeader>
				<div className='mt-2'>
					<UploadEvidenceForm
						isOpen={isOpen}
						data={data}
						handleToggleModal={handleToggleModal}
						showDetails={showDetails}
					/>
				</div>
			</Modal>
		</div>
	);
};

export default UploadEvidenceModal;